export default class LanguageSwitcher {
    constructor(container) {
        if (typeof container === 'string') {
            const found = document.querySelector(container);
            if (!found) {
                console.error('LanguageSwitcher container not found:', container);
                return;
            }
            this.container = found;
        }
        else {
            this.container = container;
        }
        this.toggleButton = this.container.querySelector('.js-wpml-ls-item-toggle');
        this.submenu = this.container.querySelector('.js-wpml-ls-sub-menu');
        this.parentItem = this.container.querySelector('.wpml-ls-item');
        if (!this.toggleButton || !this.submenu || !this.parentItem) {
            console.error('LanguageSwitcher: toggle button, submenu, or parent item not found');
            return;
        }
        this.initLanguageSwitcher();
    }
    initLanguageSwitcher() {
        this.toggleButton.addEventListener('click', (event) => {
            this.handleToggleClick(event);
        });
    }
    handleToggleClick(event) {
        const isHidden = this.submenu.getAttribute('aria-hidden') === 'true';
        if (isHidden) {
            this.openSubmenu();
        }
        else {
            this.closeSubmenu();
        }
    }
    openSubmenu() {
        this.submenu.setAttribute('aria-hidden', 'false');
        this.parentItem.setAttribute('aria-expanded', 'true');
    }
    closeSubmenu() {
        this.submenu.setAttribute('aria-hidden', 'true');
        this.parentItem.setAttribute('aria-expanded', 'false');
    }
}
